import { Button, Card, Col, Input, Row } from "antd";
import React, { useState } from "react";
import { RiAddCircleFill } from "react-icons/ri";
import { CgCloseO } from "react-icons/cg";

import "./References.css";

function References({ data }) {
  const [checked, setChecked] = useState(false);

  const [references, setReferences] = useState([
    {
      name: "",
      address: "",
      phoneNumber: "",
      relationship: "",
    },
  ]);

  const addAnotherReference = () => {
    setReferences([
      ...references,

        {
            name: "",
            address: "",
            phoneNumber: "",
            relationship: "",
          },
    
    ]);
  };

  const onRemoveReference = (index) => {
    const newReferences = [...references];
    newReferences.splice(index, 1);
    setReferences(newReferences);
  };
  return (
    <Row className="references">
      <Col span={24}>
        <Card
          title="References"
          extra={
            !checked ? (
              <span className="onclick-text" onClick={() => setChecked(true)}>
                Edit
              </span>
            ) : null
          }
        >
          {checked ? (
            <Row gutter={[0, 8]}>
              <Col span={24}>
                <Row justify="start" gutter={[8, 0]}>
                  <Col className="header-row" span={8}>
                    <span>Name</span>
                  </Col>
                  <Col className="header-row" span={8}>
                    <span>Address</span>
                  </Col>
                  <Col className="header-row" span={4}>
                    <span>Phone Number</span>
                  </Col>
                  <Col className="header-row" span={3}>
                    <span>Relationship</span>
                  </Col>
                </Row>
              </Col>
              {references.map((item, index) => {
                return (
                  <Col span={24} key={index}>
                    <Row gutter={[8, 0]} align="middle">
                      <Col span={8}>
                        <Input placeholder="Name" />
                      </Col>
                      <Col span={8}>
                        <Input placeholder="Address" />
                      </Col>
                      <Col span={4}>
                        <Input placeholder="Phone number" />
                      </Col>
                      <Col span={3}>
                        <Input placeholder="Relationship" />
                      </Col>
                      {references.length > 1 ? (
                        <Col span={1}>
                          <CgCloseO
                            className="delete-btn"
                            size={20}
                            onClick={() => onRemoveReference(index)}
                          />
                        </Col>
                      ) : null}
                    </Row>
                  </Col>
                );
              })}
              <Col span={24}>
                <button
                  onClick={() => addAnotherReference()}
                  className="add-icon-btn"
                >
                  <RiAddCircleFill size={18} />
                  <span>Add Another Pet</span>
                </button>
              </Col>
              <Col span={24} className="buttons-container">
                <Row gutter={[8, 0]}>
                  <Col>
                    <Button type="primary">Save</Button>
                  </Col>
                  <Col>
                    <Button onClick={() => setChecked(false)}>Cancel</Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          ) : (
            <Row>
              {data?.length >= 1 ? (
                <Col span={24}>
                  <Row>
                    <Col span={24}>
                      <Row gutter={[8, 0]} className="header-row">
                        <Col span={6}>
                          <span>Name</span>
                        </Col>
                        <Col span={6}>
                          <span>Address</span>
                        </Col>
                        <Col span={6}>
                          <span>Phone Number</span>
                        </Col>
                        <Col span={6}>
                          <span>Relationship</span>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  {data?.map((item, index) => {
                    return (
                      <Row gutter={[8, 0]} className="data-row" key={index}>
                        <Col span={6}>
                          <span>{item.make}</span>
                        </Col>
                        <Col span={6}>
                          <span>{item.model}</span>
                        </Col>
                        <Col span={6}>
                          <span>{item.color}</span>
                        </Col>
                        <Col span={6}>
                          <span>{item.licenseNo}</span>
                        </Col>
                      </Row>
                    );
                  })}
                </Col>
              ) : (
                <Col span={24}>
                  <Row justify="center">
                    <Col>
                      <p>Click edit to add reference.</p>
                    </Col>
                  </Row>
                </Col>
              )}
            </Row>
          )}
        </Card>
      </Col>
    </Row>
  );
}

export default References;
